import  './tls.css';
import * as jQuery from 'jquery';

jQuery(document).ready(function() {

  const userAgent = window.navigator.userAgent.toLowerCase();

  if(sessionStorage.getItem("tls-warning-dismissed")===null) {

    let isTLSSupported = false;
    let msie = userAgent.indexOf('msie ');

    if (userAgent.indexOf('chrome/') > -1) {
      if (getVersion('chrome/') > 29) {
        isTLSSupported = true;
      }
    } else if (userAgent.indexOf('edge/') > -1) {
      if (getVersion('edge/') > 11) {
        isTLSSupported = true;
      }
    } else if (userAgent.indexOf('safari/') > -1) {
      if (getVersion('safari/') > 6) {
        isTLSSupported = true;
      }
    } else if (msie > -1) {
      let version = parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
      if (version > 10) {
        isTLSSupported = true;
      }
    } else if (userAgent.indexOf('trident/') > -1) {
      if (getVersion('trident/') > 6) {
        isTLSSupported = true;
      }
    } else if (userAgent.indexOf('firefox/') > -1) {
      if (getVersion('firefox/') > 26) {
        isTLSSupported = true;
      }
    } else if (userAgent.indexOf('opera/') > -1) {
      if (getVersion('opera/') > 15) {
        isTLSSupported = true;
      }
    }

    if (!isTLSSupported) {
      jQuery(".top-notification-container").show();
      // gtag('event', 'show-unsupported-tls-browser-warning', 'Browser does not support TLS 1.2');
    }

  }

  function getVersion(browser) {
    return Number(userAgent.split(browser)[1].split('.')[0]);
  }

  jQuery("#more").click(function more() {
    jQuery(".message-details").slideToggle();
    (jQuery(".more").text() === 'more...') ? jQuery(".more").text('less...') : jQuery(".more").text('more...');
  });

  jQuery("#close").click(function closeNotification() {
    jQuery(".top-notification-container").slideUp();
    sessionStorage.setItem("tls-warning-dismissed", "true");
  });

});
